<ng-container *transloco="let t">
    <div class="blue-background" *ngIf="!client?.isEnabled"></div>
    <header
        *ngIf="!client?.isEnabled"
        fxLayout="column"
        focusonnavigation=""
        aria-label="Get started"
        id="homepage-header"
        class="home-header-background"
        tabindex="-1"
    >
        <div
            fxFlexFill
            fxLayout="column"
            fxLayoutAlign="start center"
            class="home-header-section"
        >
            <div class="home-header-headline">
                <h1>{{ client?.clientName }}</h1>
                <h2>{{ client?.siteDisabledHtml }}</h2>
            </div>
        </div>
    </header>
    <div class="content-area" *ngIf="client?.isEnabled">
        <div
            class="container search-area"
            fxFlex="100"
            fxLayout="row"
            fxLayoutAlign="center start"
            fxFlexFill
        >
            <app-provider-search
                fxFlex="940px"
                fxFlex.lt-md="90%"
                fxFlexFill
                (searchEvent)="searchProviders($event)"
                [formattedSearchAddress]="formattedSearchAddress"
            ></app-provider-search>
        </div>
    </div>
    <div class="content-area" *ngIf="client?.isEnabled">
        <div
            class="container results-area"
            fxFlex="940px"
            fxFlex.lt-md="90%"
            fxFlexFill
        >
            <app-provider-card-collection
                [providers]="providers"
                [filtered]="searchParams.filtered"
                [loading]="(loading$ | async) ?? false"
                (sortEvent)="sortProviders($event)"
            ></app-provider-card-collection>
        </div>
    </div>
</ng-container>
